<template>
	<v-menu
		v-model="showPicker"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		:min-width="minWidth"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				:value="friendlyDateString"
				@input="onNewDate"
				:disabled="disabled"
				:label="label"
				:rules="rules"
				readonly
				:clearable="clearable"
				v-on="on"
				prepend-icon="fa-calendar-alt"
			/>
		</template>
		<v-date-picker v-model="currentValue" @input="onNewDate" :min="min" :max="max" />
	</v-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import LocalDateTime from '@/util/LocalDateTime';

@Component
export default class TextBoxDatePicker extends Vue {
	@Prop({ default: '' }) value: any;

	@Prop({ default: false }) disabled: any;

	@Prop() label: any;

	@Prop() max: any;

	@Prop() min: any;

	@Prop() minWidth: any;

	@Prop() rules: any;

	@Prop({ default: false }) clearable!: boolean;

	friendlyDateString: string = '';

	dateString: string = '';

	showPicker: boolean = false;

	currentValue: any = '';

	mounted() {
	  if (this.value) {
	    this.onNewValue();
	  }
	}

	@Watch('value')
	@Watch('friendlyDateString')
	onNewValue() {
	  if (this.value && this.value.length > 0) {
	    const localDate: LocalDateTime = new LocalDateTime(this.value);
	    this.friendlyDateString = localDate.toFriendlyDateString();
	    this.currentValue = this.value;
	  } else {
	    this.friendlyDateString = '';
	    this.currentValue = null;
	  }
	}

	onNewDate(date: string) {
	  this.showPicker = false;
	  this.currentValue = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	  this.friendlyDateString = localDate.toFriendlyDateString();
	  this.$emit('input', date);
	}
}
</script>
